import { Redirect, useLocalSearchParams } from "expo-router";

export default function Index() {
  const { qr } = useLocalSearchParams<{ qr?: string }>();

  return <Redirect href={qr ? `/welcome?qr=${qr}` : "/welcome"} />;
}
